module.exports = __webpack_public_path__ + "img/red-super-soup.3cda0126.jpg";